import { AppBar, BottomNavigation, BottomNavigationAction, Box, Button, IconButton, makeStyles, Tab, Tabs, Toolbar, Typography } from '@material-ui/core';
import { useEffect, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { COLORS } from '../Theme';

const useStyles = makeStyles((theme) => ({
	appBar: {
		top: 0,
		height: '12vh',
		// minHeight: '104px',
		bottom: 'auto',
		backgroundColor: `${COLORS.WATER_BLUE}`,
		boxShadow: 'none',
	},
	appBar2: {
		top: 0,
		paddingTop: '1vh',
		height: '7vh',
		// minHeight: '104px',
		bottom: 'auto',
		backgroundColor: `${COLORS.WATER_BLUE}`,
		boxShadow: 'none',
	},
	logoBar: {
		height: '62%',
		minHeight: '32px',
	},
	logo: {
		margin: 'auto',
		'& img': {
			width: '45vw',
		},
	},
	IconSize: {
		width: '6vw',
		height: '6vw',
	},

	tabBar: {
		height: '38%',
		minHeight: '30px',

		'& > div > div': {
			height: '100%',
		},
		'& > div > div > a': {
			height: '100%',
			minHeight: '30px',
			minWidth: '20vw',
		},
		'& .Mui-selected': {
			color: `${COLORS.WHITE}`,
			fontFamily: 'NanumB',
			fontWeight: 'bold',
		},
		'& .MuiTabs-indicator': {
			backgroundColor: `${COLORS.PUMPKIN}`,
		},
	},
	linkTab: {
		fontSize: '2.5vw',
		fontFamily: 'NanumR',
		padding: 0,
		'&:hover': {
			color: `${COLORS.WHITE}`,
		},
	},

	topNav: {
		width: '100vw',
		height: '10vh',
		top: 0,
		bottom: 'auto',

		borderRadius: '36px 36px 0 0',
		boxShadow: '0 3px 6px 0 rgba(0, 0, 0, 0.16)',
		// border: `solid 0.5px ${COLORS.VERY_LIGHT_PINK}`,
		// backgroundColor: `${COLORS.WHITE}`,
	},
	navigationBtn: {
		width: '20%',
		minWidth: 50,
	},
	navigator: {
		display: 'grid',
		gridTemplateColumns: '1fr 2fr',
		marginTop: '1%',
	},
	title: {
		margin: '2vh 0px 0px 35px',
		fontFamily: 'NanumR',
		fontSize: '1.5rem',
		fontWeight: 'bold',
		display: 'flex',
		gap: '10vw',
		//color: `${COLORS.WHITE}`,
	},
	subTitle: {
		minWidth: '10vw',
		display: 'flex',
		flexDirection: 'column',
		position: 'relative', // ⭐ 부모를 상대 위치로
	},
	menu: {
		display: 'grid',
		border: 'none',
		borderWidth: '0px 0px 1px 0px',
		fontFamily: 'NanumR',
		fontSize: '1.5rem',
		fontWeight: 'bold',
		'&::after': {
			content: '""',
			position: 'absolute',
			width: '0',
			height: '0',
			left: '50%',
			bottom: '0',
			borderBottom: '3px solid black',
			transition: 'width 0.3s ease, left 0.3s ease',
			WebkitTransition: 'width 0.3s ease, left 0.3s ease',
		},
		'&:hover::after': {
			width: '100%',
			left: '0',
		},
		'&:hover': {
			backgroundColor: 'transparent', // hover 배경색 제거
		},
	},
	menuOpen: {
		position: 'absolute', // ⭐ 떠 있게
		top: '100%',
		left: 0,
		zIndex: 1000,
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'stretch',
		gap: '10px',

		width: '100%',
		padding: '10px 12px',
		backgroundColor: '#fff',
		border: '1px solid rgba(0,0,0,0.12)',
		boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
		borderRadius: '8px',
		'& a': {
			margin: 0,
			fontSize: '0.95rem',
			width: '100%',
			height: 'auto',
			cursor: 'pointer',
			position: 'relative',
			padding: '6px 8px',
			borderRadius: '6px',
			'&:hover': { backgroundColor: 'rgba(0,0,0,0.04)' },
		},
	},
	menuClose: {
		display: 'none',
	},
	logo2: {
		display: 'flex',
		flexWrap: 'wrap',
		alignItems: 'stretch',
		//border: 'solid white',
		margin: '2vh 0px',
		borderWidth: '0px 0px 1px 0px',
		//cursor: 'pointer',
		'& img': {
			width: '30px',
			height: '30px',
			margin: '12px 5px 0px 9%',
		},
		'& #name': {
			display: 'inline-block',
			margin: '10px 0px 0px 0px',
			width: 'calc(91% - 35px)',
			fontFamily: 'NanumR',
			fontSize: '1.5rem',
			fontWeight: 'bolder',
		},
		'& #welcome': {
			display: 'block',
			margin: '5px 0px 0px 9%',
			fontFamily: 'NanumR',
			fontSize: '1.2rem',
		},
	},
}));

function a11yProps(index: any) {
	return {
		id: `nav-tab-${index}`,
		'aria-controls': `nav-tabpanel-${index}`,
	};
}

interface LinkTabProps {
	label?: string;
	href?: string;
	history?: any;
	classNameProps?: any;
	member?: any;
	[key: string]: any;
}

function LinkTab(props: LinkTabProps) {
	const { classNameProps, history, href, member, ...other } = props;

	return (
		<Tab
			component="a"
			href={href}
			onClick={(event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
				event.preventDefault();
				history.push({
					pathname: href,
					...(member && {
						state: {
							code: member.classCode,
						},
					}),
				});
			}}
			className={classNameProps}
			{...other}
		/>
	);
}

const pathToTabIndex = (paths: string[], path: string): number | false => {
	const normalized = path.split('?')[0].replace(/\/$/, '') || '/';
	if (normalized === '/') return 0;
	const idx = paths.findIndex((element) => element === normalized || element === path);
	return idx >= 0 ? idx : false;
};

// 경영현황 / 연구개발 / 재료구매 / 제품생산 / 제품판매
const address = ['/CompanyInfo', '/LicenseList', '/ProductionList', '/MaterialPurchase', '/ProductList' /*'/ProductSale'*/];
const HeaderBar: React.FC<any> = (props) => {
	const classes = useStyles();
	const { t } = useTranslation('common');

	const [value, setValue] = useState(pathToTabIndex(address, window.location.pathname));
	const history = useHistory();

	const goSetting = () => {
		history.push(`/setting`);
	};

	const goQnA = () => {
		history.push(`/qna`);
	};

	const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
		setValue(newValue);
	};

	const refresh = () => {
		window.location.reload();
	};

	useEffect(() => {
		if (history === undefined) return;
		return history.listen((location: any) => {
			setValue(pathToTabIndex(address, location.pathname));
		});
	}, [history]);

	return (
		<>
			<AppBar position="static" className={classes.appBar}>
				<Toolbar className={classes.logoBar}>
					<Box display="flex" style={{ width: '100%' }}>
						<Box flexGrow={1} className={classes.logo}>
							<img src="/images/logo_white.png" />
						</Box>
						<Box>
							<IconButton onClick={goQnA} style={{ padding: 0 }}>
								<img className={classes.IconSize} src="/images/question.png" />
							</IconButton>
							<IconButton onClick={goSetting} style={{ padding: 0, paddingLeft: '3vw' }}>
								<img className={classes.IconSize} src="/images/Settings.webp" />
							</IconButton>
							<IconButton onClick={refresh} style={{ padding: 0, paddingLeft: '3vw' }}>
								<img className={classes.IconSize} src="/images/refresh_white2.png" />
							</IconButton>
						</Box>
					</Box>
				</Toolbar>
				<Tabs className={classes.tabBar} variant="fullWidth" value={value} onChange={handleChange} aria-label="nav tabs">
					<LinkTab classNameProps={classes.linkTab} label={t('HeaderBar.tabCompanyInfo')} href={address[0]} history={history} {...a11yProps(0)} data-testid="company-info-tab" />
					<LinkTab classNameProps={classes.linkTab} label={t('HeaderBar.tabLicenseList')} href={address[1]} history={history} {...a11yProps(1)} data-testid="manu-license-list-tab" />
					<LinkTab classNameProps={classes.linkTab} label={t('HeaderBar.tabProductionList')} href={address[2]} history={history} {...a11yProps(2)} data-testid="manu-production-tab" />
					<LinkTab
						classNameProps={classes.linkTab}
						label={t('HeaderBar.tabMaterialPurchase')}
						href={address[3]}
						history={history}
						{...a11yProps(3)}
						data-testid="manu-material-purchase-tab"
					/>
					<LinkTab classNameProps={classes.linkTab} label={t('HeaderBar.tabProductList')} href={address[4]} history={history} {...a11yProps(4)} data-testid="manu-product-tab" />
				</Tabs>
			</AppBar>
		</>
	);
};

const oper_address = ['/operation/company/list', '/operation/decomposition/appList', '/operation/classCode', '/operation/ClassRun'];
export const OperHeaderBar: React.FC<any> = (props) => {
	const classes = useStyles();
	const { t } = useTranslation('common');
	const [value, setValue] = useState(pathToTabIndex(oper_address, window.location.pathname));
	const { oper } = props;
	const history = useHistory();

	const goSetting = () => {
		history.push(`/setting`);
	};

	const goQnA = () => {
		history.push(`/qna`);
	};

	const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
		setValue(newValue);
	};

	const refresh = () => {
		history.go(0);
	};

	useEffect(() => {
		if (history === undefined) return;
		return history.listen((location: any) => {
			setValue(pathToTabIndex(oper_address, location.pathname));
		});
	}, [history]);

	return (
		<>
			<AppBar position="static" className={classes.appBar}>
				<Toolbar className={classes.logoBar}>
					<Box display="flex" style={{ width: '100%' }}>
						<Box flexGrow={1} className={classes.logo}>
							<img src="/images/logo_white.png" />
						</Box>
						<Box>
							<IconButton onClick={goQnA} style={{ padding: 0 }}>
								<img className={classes.IconSize} src="/images/question.png" />
							</IconButton>
							<IconButton onClick={goSetting} style={{ padding: 0, paddingLeft: '3vw' }}>
								<img className={classes.IconSize} src="/images/Settings.webp" />
							</IconButton>
							<IconButton onClick={refresh} style={{ padding: 0, paddingLeft: '3vw' }}>
								<img className={classes.IconSize} src="/images/refresh_white2.png" />
							</IconButton>
						</Box>
					</Box>
				</Toolbar>
				<Tabs className={classes.tabBar} variant="fullWidth" value={value} onChange={handleChange} aria-label="nav tabs">
					<LinkTab
						classNameProps={classes.linkTab}
						label={t('HeaderBar.operTabCompanyList')}
						href={oper_address[0]}
						history={history}
						{...a11yProps(0)}
						data-testid="oper-company-list-tab"
					/>
					<LinkTab
						classNameProps={classes.linkTab}
						label={t('HeaderBar.operTabDecompositionAppList')}
						href={oper_address[1]}
						history={history}
						{...a11yProps(1)}
						data-testid="oper-decomposition-manage-tab"
					/>
					<LinkTab
						classNameProps={classes.linkTab}
						label={t('HeaderBar.operTabClassQr')}
						href={oper_address[2]}
						history={history}
						{...a11yProps(2)}
						member={oper}
						data-testid="oper-class-qr-tab"
					/>
					<LinkTab
						classNameProps={classes.linkTab}
						label={t('HeaderBar.operTabRanking')}
						href={oper_address[3]}
						history={history}
						{...a11yProps(3)}
						member={oper}
						data-testid="oper-ranking-tab"
					/>
				</Tabs>
			</AppBar>
		</>
	);
};

// 경영현황 / 재료판매(승인) / 재료목록 / 재료구매
const d_address = ['/CompanyInfo', '/MaterialSale', '/ProductPurchase', '/MaterialList', '/ProductPurchaseList'];
const d_tab_paths = [d_address[0], d_address[1], d_address[2], d_address[4]];
export const DistributionHeaderBar: React.FC<any> = (props) => {
	const classes = useStyles();
	const { t } = useTranslation('common');

	const [value, setValue] = useState(pathToTabIndex(d_tab_paths, window.location.pathname));
	const history = useHistory();

	const goSetting = () => {
		history.push(`/setting`);
	};

	const goQnA = () => {
		history.push(`/qna`);
	};

	const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
		setValue(newValue);
	};

	const refresh = () => {
		window.location.reload();
	};

	useEffect(() => {
		if (history === undefined) return;
		return history.listen((location: any) => {
			setValue(pathToTabIndex(d_tab_paths, location.pathname));
		});
	}, [history]);

	return (
		<>
			<AppBar position="static" className={classes.appBar}>
				<Toolbar className={classes.logoBar}>
					<Box display="flex" style={{ width: '100%' }}>
						<Box flexGrow={1} className={classes.logo}>
							<img src="/images/logo_white.png" />
						</Box>
						<Box>
							<IconButton onClick={goQnA} style={{ padding: 0 }}>
								<img className={classes.IconSize} src="/images/question.png" />
							</IconButton>
							<IconButton onClick={goSetting} style={{ padding: 0, paddingLeft: '3vw' }}>
								<img className={classes.IconSize} src="/images/Settings.webp" />
							</IconButton>
							<IconButton onClick={refresh} style={{ padding: 0, paddingLeft: '3vw' }}>
								<img className={classes.IconSize} src="/images/refresh_white2.png" />
							</IconButton>
						</Box>
					</Box>
				</Toolbar>
				<Tabs className={classes.tabBar} variant="fullWidth" value={value} onChange={handleChange} aria-label="nav tabs">
					<LinkTab classNameProps={classes.linkTab} label={t('HeaderBar.distTabCompanyInfo')} href={d_address[0]} history={history} {...a11yProps(0)} data-testid="company-info-tab" />
					<LinkTab classNameProps={classes.linkTab} label={t('HeaderBar.distTabMaterialSale')} href={d_address[1]} history={history} {...a11yProps(1)} data-testid="dist-material-sale-tab" />
					<LinkTab
						classNameProps={classes.linkTab}
						label={t('HeaderBar.distTabProductPurchase')}
						href={d_address[2]}
						history={history}
						{...a11yProps(2)}
						data-testid="dist-product-purchase-tab"
					/>
					{/* <LinkTab classNameProps={classes.linkTab} label="보유재료" href={d_address[3]} history={history} {...a11yProps(2)} /> */}
					<LinkTab classNameProps={classes.linkTab} label={t('HeaderBar.distTabOwnedProduct')} href={d_address[4]} history={history} {...a11yProps(3)} data-testid="dist-owned-product-tab" />
				</Tabs>
			</AppBar>
		</>
	);
};

// 경영현황 / 제품구매(승인) / 제품목록 / 재료목록 / 재료판매(승인)
const s_address = ['/CompanyInfo', '/ProductPurchase', '/ProductList', '/MaterialList', '/MaterialSale'];
export const ServiceHeaderBar: React.FC<any> = (props) => {
	const classes = useStyles();
	const { t } = useTranslation('common');
	const [value, setValue] = useState(pathToTabIndex(s_address, window.location.pathname));
	const history = useHistory();

	const goSetting = () => {
		history.push(`/setting`);
	};

	const goQnA = () => {
		history.push(`/qna`);
	};

	const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
		setValue(newValue);
	};

	const refresh = () => {
		window.location.reload();
	};

	useEffect(() => {
		if (history === undefined) return;
		return history.listen((location: any) => {
			setValue(pathToTabIndex(s_address, location.pathname));
		});
	}, [history]);

	return (
		<>
			<AppBar position="static" className={classes.appBar}>
				<Toolbar className={classes.logoBar}>
					<Box display="flex" style={{ width: '100%' }}>
						<Box flexGrow={1} className={classes.logo}>
							<img src="/images/logo_white.png" />
						</Box>
						<Box>
							<IconButton onClick={goQnA} style={{ padding: 0 }}>
								<img className={classes.IconSize} src="/images/question.png" />
							</IconButton>
							<IconButton onClick={goSetting} style={{ padding: 0, paddingLeft: '3vw' }}>
								<img className={classes.IconSize} src="/images/Settings.webp" />
							</IconButton>
							<IconButton onClick={refresh} style={{ padding: 0, paddingLeft: '3vw' }}>
								<img className={classes.IconSize} src="/images/refresh_white2.png" />
							</IconButton>
						</Box>
					</Box>
				</Toolbar>
				<Tabs className={classes.tabBar} variant="fullWidth" value={value} onChange={handleChange} aria-label="nav tabs">
					<LinkTab classNameProps={classes.linkTab} label={t('HeaderBar.serviceTabCompanyInfo')} href={s_address[0]} history={history} {...a11yProps(0)} />
					<LinkTab classNameProps={classes.linkTab} label={t('HeaderBar.serviceTabProductPurchase')} href={s_address[1]} history={history} {...a11yProps(1)} />
					<LinkTab classNameProps={classes.linkTab} label={t('HeaderBar.serviceTabProductList')} href={s_address[2]} history={history} {...a11yProps(2)} />
					<LinkTab classNameProps={classes.linkTab} label={t('HeaderBar.serviceTabMaterialList')} href={s_address[3]} history={history} {...a11yProps(3)} />
					<LinkTab classNameProps={classes.linkTab} label={t('HeaderBar.serviceTabMaterialSale')} href={s_address[4]} history={history} {...a11yProps(4)} />
				</Tabs>
			</AppBar>
		</>
	);
};

export const OperatorHeaderBar: React.FC<any> = (props) => {
	const classes = useStyles();
	const history = useHistory();

	const goSetting = () => {
		history.push(`/setting`);
	};

	const goQnA = () => {
		history.push(`/qna`);
	};

	const refresh = () => {
		history.go(0);
	};

	return (
		<>
			<AppBar position="static" className={classes.appBar2}>
				<Toolbar className={classes.logoBar}>
					<Box display="flex" style={{ width: '100%' }}>
						<Box flexGrow={1} className={classes.logo}>
							<img src="/images/logo_white.png" />
						</Box>
						<Box>
							<IconButton onClick={goQnA} style={{ padding: 0 }}>
								<img className={classes.IconSize} src="/images/question.png" />
							</IconButton>
							<IconButton onClick={goSetting} style={{ padding: 0, paddingLeft: '3vw' }}>
								<img className={classes.IconSize} src="/images/Settings.webp" />
							</IconButton>
							<IconButton onClick={refresh} style={{ padding: 0, paddingLeft: '3vw' }}>
								<img className={classes.IconSize} src="/images/refresh_white2.png" />
							</IconButton>
						</Box>
					</Box>
				</Toolbar>
			</AppBar>
		</>
	);
};

export const TopNavigation = () => {
	const classes = useStyles();
	const [value, setValue] = useState(setInitValue(window.location.pathname));
	const { t } = useTranslation('common');
	const handleChange = (event: any, newValue: any) => {
		setValue(newValue);
	};

	// change to useMemo?
	function setInitValue(path: string) {
		if (path == '/' || path == '/test') {
			return 0;
		} else if (path == '/login') {
			return 1;
		} else if (path == '/operation/') {
			return 2;
		} else if (path == '/operation/product/purchase/list') {
			return 3;
		} else {
			return 0;
		}
	}

	return (
		<BottomNavigation value={value} onChange={handleChange} showLabels className={classes.topNav}>
			<BottomNavigationAction className={classes.navigationBtn} selected={true} component={Link} to="/test" value={0} label={t('HeaderBar.topNavMaterialOrder')} />
			<BottomNavigationAction className={classes.navigationBtn} component={Link} to="/login" value={1} label={t('HeaderBar.topNavMaterialDone')} />
			<BottomNavigationAction className={classes.navigationBtn} component={Link} to="/operation" value={2} label={t('HeaderBar.topNavProductOrder')} />
		</BottomNavigation>
	);
};

export const SubAdminHeaderBar: React.FC<any> = (props) => {
	const classes = useStyles();
	const history = useHistory();
	const { t } = useTranslation('common');
	const [menu, setMenu] = useState<boolean>(false);
	const [operMenu, setOperMenu] = useState<boolean>(false);

	const moveClassList = () => {
		history.push('/subAdminClassList');
	};
	const moveClassManage = () => {
		history.push('/subAdminClassManage');
	};
	const moveOperList = () => {
		history.push('/subAdminOperList');
	};
	const moveOperAffiliate = () => {
		history.push('/subAdminOperAffiliate');
	};
	const moveOperClassList = () => {
		history.push('/subAdminClassList2');
	};

	return (
		<>
			<div className={classes.navigator}>
				<div className={classes.logo2}>
					<img src="/images/p.webp"></img>
					<Typography id="name">{t('HeaderBar.subAdminBrand')}</Typography>
				</div>
				<div className={classes.title}>
					<div
						className={classes.subTitle}
						onMouseOver={() => {
							setMenu(true);
						}}
						onMouseOut={() => {
							setMenu(false);
						}}
					>
						<Button className={classes.menu} onClick={(e) => moveClassList()}>
							{t('HeaderBar.subAdminMenuEdu')}
						</Button>
						<div className={menu ? classes.menuOpen : classes.menuClose}>
							<Button onClick={(e) => moveClassList()}>{t('HeaderBar.subAdminEduList')}</Button>
							<Button onClick={(e) => moveClassManage()}>{t('HeaderBar.subAdminEduManageList')}</Button>
							<Button onClick={(e) => moveOperClassList()}>{t('HeaderBar.subAdminTeacherEduList')}</Button>
						</div>
					</div>
					<div
						className={classes.subTitle}
						onMouseOver={() => {
							setOperMenu(true);
						}}
						onMouseOut={() => {
							setOperMenu(false);
						}}
					>
						<Button className={classes.menu} onClick={(e) => moveOperList()}>
							{t('HeaderBar.subAdminMenuTeacher')}
						</Button>
						<div className={operMenu ? classes.menuOpen : classes.menuClose}>
							<Button onClick={(e) => moveOperList()}>{t('HeaderBar.subAdminTeacherApprove')}</Button>
							<Button onClick={(e) => moveOperAffiliate()}>{t('HeaderBar.subAdminTeacherAffiliateManage')}</Button>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default HeaderBar;
